module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_1250_Inactive@1x-989714fce006489426e03d15b9edc173.png";